import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardTokenListComponent } from './components/card-token-list/card-token-list.component';
import { AddNewCardComponent } from './components/add-new-card/add-new-card.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from 'src/app/shared/shared.module';
import { UserModule } from '../user/user.module';
import { CardTokenComponent } from './components/card-token/card-token.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ConfirmModalModule } from '@fgb/portal-component-library/src/lib/shared/confirm-modal';
@NgModule({
  declarations: [
    CardTokenComponent,
    CardTokenListComponent,
    AddNewCardComponent
  ],
  imports: [
    NgbModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    UserModule,
    ConfirmModalModule,
    CarouselModule,
    InlineSVGModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: function HttpLoaderFactory(http: HttpClient) {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    CardTokenComponent,
    CardTokenListComponent,
    AddNewCardComponent
  ],
})
export class EcashModule {}
